import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';
import { JsonDataService } from './services/commonData/json-data.service';
import { ErrorHandlingService } from './services/error-handling/error-handling.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

export const authGuard: CanActivateFn = (route, state) => {
  const sessionStorage = inject(SessionStorageService);
  const router = inject(Router);
  const jsonService = inject(JsonDataService);
  const errorHandling = inject(ErrorHandlingService);
  var check;
  var isLdap;

  jsonService.getValueFromJSON().then((res: any) =>
  {
    isLdap = res.Ldap[0].Value;
  }).catch(err => {
    console.log(err);
    errorHandling.checkError(500);
  });


  check = sessionStorage?.retrieve('isUserLoggedIn');
  if (check === true)
  {
    return true;
  } else
  {
    Swal.fire({ 
      title : "Login to Continue", 
      text : "", 
      icon : "warning", 
      allowOutsideClick : false 
    });
    router?.navigate(['authentication/login'])
    sessionStorage?.clear();
    return false;
  }
};
